/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Account_N_Technical__DescriptionInputs */

const en_help_center__account_n_technical__description = /** @type {(inputs: Help_Center__Account_N_Technical__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery areas, shipping costs, and product warranties`)
};

/**
* | output |
* | --- |
* | "Delivery areas, shipping costs, and product warranties" |
*
* @param {Help_Center__Account_N_Technical__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__account_n_technical__description = /** @type {((inputs?: Help_Center__Account_N_Technical__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Account_N_Technical__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__account_n_technical__description(inputs)
});